<template>
  <!-- Repeating pattern: use CSS background-image (no fade) -->
  <div
    v-if="image && image.url && isRepeating"
    ref="imageElement"
    data-testid="strapi-background-image"
    class="absolute w-full h-full overflow-hidden"
    :style="{
      'background-image': imagePath,
      'background-repeat': repeat,
      'background-size': 'auto',
    }"
  ></div>

  <!-- Single hero image: use <img> so height is intrinsic and fade works -->
  <div
    v-else-if="image && image.url"
    ref="imageElement"
    data-testid="strapi-background-image"
    class="absolute top-0 left-0 w-full overflow-hidden mask-[linear-gradient(to_bottom,black_50%,transparent_100%)] [-webkit-mask-image:linear-gradient(to_bottom,black_50%,transparent_100%)]"
  >
    <img
      v-if="imagePath"
      :src="image.url"
      alt=""
      class="block h-screen w-full object-cover object-top lg:h-auto lg:object-contain"
    />
  </div>
</template>

<script setup lang="ts">
import type { StrapiImage } from '~/apollo/types/types';
import { RepeatType } from '~/components/strapi/types';

const props = defineProps({
  image: {
    type: Object as PropType<StrapiImage>,
    required: true,
  },
  repeat: {
    type: String as PropType<RepeatType>,
    default: RepeatType.NO,
  },
});

const imageElement = ref<HTMLElement>();
const imageElementVisible = useElementVisibility(imageElement);
const wasVisible = ref<boolean>(false);

const isRepeating = computed(() => props.repeat !== RepeatType.NO);

const imagePath = computed<string>(() => {
  if (imageElementVisible.value || wasVisible.value) {
    return `url(${props.image.url})`;
  }

  return undefined;
});

watch(
  () => imageElementVisible.value,
  (val: boolean) => {
    if (val === true) {
      wasVisible.value = true;
    }
  },
);
</script>
